import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  // --------
  IconCartNavBar: {
    color: "#121212",
    //color: "#f1b211", // yellow cart icon, not the number of the circle when the user adds a product
    // color: "red", //
    // border: "3px solid #121212",
    // borderRadius: "193px 193px 193px 193px",
    // padding: "20px 35px",
    // background: "transparent",
  },

  //badge
  customBadge: {
    width: "45px",
    height: "45px",
    borderRadius: "100px",
    backgroundColor: "#00ffb3",
    clipPath: `polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);`,

    color: "green",
  },
}));
